export const getRankingPath = (userGroupId: string) => {
  return `/user_groups/${userGroupId}/ranking`;
};
